import {get} from "lodash";
import {IPlayer} from "modules/types";
import {PlayerPositionEnum} from "modules/enums";

export interface IPlayerStatsItem {
	value?: number;
	key: string;
	isShowDecimal: boolean;
	isHideZeroValue: boolean;
}

export const getPlayerStats = (player: IPlayer) => {
	const generalStats = [
		{value: player.stats.sacks, key: "player.modal.sk"},
		{value: player.stats.tackles, key: "player.modal.tk"},
		{value: player.stats.interceptions, key: "player.modal.int"},
		{value: player.stats.fumblesForced, key: "player.modal.ff"},
		{value: player.stats.knockdowns, key: "player.modal.pkd"},
		{value: player.stats.tacklesForLoss, key: "player.modal.tfl"},
	];

	const stats = {
		[PlayerPositionEnum.QB]: [
			{value: player.stats.passingAttempts, key: "player.modal.pa"},
			{value: player.stats.passingCompletions, key: "player.modal.pc"},
			{value: player.stats.passingYards, key: "player.modal.pass_yds"},
			{value: player.stats.passingTouchdowns, key: "player.modal.pass_tds"},
			{value: player.stats.QBRating, key: "player.modal.qb_rt", isShowDecimal: true},
			{value: player.stats.passingInterceptions, key: "player.modal.pass_int"},
		],
		[PlayerPositionEnum.RB]: [
			{value: player.stats.rushingAttempts, key: "player.modal.ra"},
			{value: player.stats.rushingYards, key: "player.modal.rush_yds"},
			{
				value: player.stats.rushingYardsAverage,
				key: "player.modal.rush_yds_avg",
				isShowDecimal: true,
			},
			{value: player.stats.rushingTouchdowns, key: "player.modal.rush_tds"},
			{value: player.stats.rushingLong, key: "player.modal.rl"},
			{value: player.stats.receivingYards, key: "player.modal.rec_yds"},
		],
		[PlayerPositionEnum.WR]: [
			{value: player.stats.receivingYards, key: "player.modal.rec_yds"},
			{value: player.stats.targets, key: "player.modal.tar"},
			{value: player.stats.receivingReceptions, key: "player.modal.rec"},
			{
				value: player.stats.receivingYardsAverage,
				key: "player.modal.rec_yds_avg",
				isShowDecimal: true,
			},
			{value: player.stats.receivingLong, key: "player.modal.rec_l"},
			{value: player.stats.receivingTouchdowns, key: "player.modal.rec_tds"},
		],
		[PlayerPositionEnum.DL]: generalStats,
		[PlayerPositionEnum.LB]: generalStats,
		[PlayerPositionEnum.DB]: generalStats,
		[PlayerPositionEnum.OL]: [
			{value: player.stats.gamesPlayed, key: "player.modal.gp"},
			// {value: player.stats.gamesStarted, key: "player.modal.gs"},
			// {value: player.stats.teamSacksAllowed, key: "player.modal.team_sk_allowed"},
		],
		[PlayerPositionEnum.K]: [
			{value: player.stats.fieldGoalAttempts, key: "player.modal.fga"},
			{value: player.stats.fieldGoalsMade, key: "player.modal.fgm"},
			{value: player.stats.fieldGoalsPct, key: "player.modal.fg%", isShowDecimal: true},
			{value: player.stats.fieldGoalsLong, key: "player.modal.fgl"},
			// {value: player.stats.fieldGoalYards, key: "player.modal.fg50"},
			{value: player.stats.pointsScored, key: "player.modal.pts"},
		],
		[PlayerPositionEnum.P]: [
			{value: player.stats.punts, key: "player.modal.p"},
			{value: player.stats.puntYards, key: "player.modal.punt_yds"},
			{value: player.stats.averageYards, key: "player.modal.avg_yds", isShowDecimal: true},
			// {value: player.stats.puntIn10, key: "player.modal.p_in_10"},
			{value: player.stats.singles, key: "player.modal.sing"},
			{value: player.stats.puntsLong, key: "player.modal.pl"},
		],
		[PlayerPositionEnum.ST]: [
			{value: player.stats.returns, key: "player.modal.r", isHideZeroValue: true},
			{value: player.stats.returnsYards, key: "player.modal.r_yds", isHideZeroValue: true},
			{
				value: player.stats.kickoffReturnsAverage,
				key: "player.modal.kr_avg",
				isHideZeroValue: true,
			},
			{value: player.stats.specialTeamsTackles, key: "player.modal.st_tk"},
			{
				value: player.stats.puntReturnsAverage,
				key: "player.modal.pr_avg",
				isHideZeroValue: true,
			},
			{
				value: player.stats.returnsTouchdowns,
				key: "player.modal.ret_tds",
				isHideZeroValue: true,
			},
		],
	};

	return stats[player.position].filter((stat) => {
		const isHideZeroValue = get(stat, "isHideZeroValue", false) as boolean;

		return !(isHideZeroValue && !stat.value);
	}) as IPlayerStatsItem[];
};
